<template>
  <div id="my">
      <section class="menuFour">
          <ul>
            <li class="per"><router-link to="/BxComplain"  >报修记录<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
            <li class="pay"><router-link to="/complainListQingMeng">投诉建议记录<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
          </ul>
      </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.right2{
    width: 12px;
    height: 21px;
}
#my{
    width: 100%;
    height: 100%;
    background-color: #eee;
}
#my .top{
    height: 236px;
    margin-bottom: 18px;
    background-color: #fff;
}
#my .top img{
    float: left;
    margin-left: 46px;
    margin-top: 53px;
    width: 148px;
    height: 148px;
    border-radius: 74px;
}

#my .top h5{
    float: left;
    color: #333;
    margin-left: 20px;
    margin-top: 105px;
    font-size: 40px;
    font-weight: 400;
}
#my .menuFour{
    background-color: #fff;
}
 #my .menuFour ul{
      width: 100%;
      box-sizing: border-box;
      padding: 35px 31px 0 31px;
 }
#my .menuFour ul li{
      line-height: 100px;
      box-sizing: border-box;
      border-bottom: 1px solid #f5f5f5;
  }
#my .menuFour ul li a{
    display: inline-block;
    text-align: left;
    width: 100%;
    height: 100%;
    line-height: 4;
    font-size:32px;
    margin-left: 22px;
    box-sizing: border-box;
}
#my .menuFour ul li a span{
    font-size: 30px;
    float: right;
    color:#DAD8D8;
    margin-right: 20px;
}
/*个人信息选项*/
#my .menuFour ul .per a{
    /*background: url(/static/img/per2.png)no-repeat;*/
    /*background-position: 0px 50px;*/
    /*background-size: 30px 30px;*/
    padding-left: 15px;
}
/*缴费记录选项*/
#my .menuFour ul .pay a{
    /*background: url(/static/img/pay2.png)no-repeat;*/
    /*background-position: 0px 50px;*/
    /*background-size: 30px 30px;*/
    padding-left: 15px;
}
/*服务记录选项*/
#my .menuFour ul .serReport a{
    /*background: url(/static/img/serReport.png)no-repeat;*/
    /*background-position: 0px 50px;*/
    /*background-size: 30px 30px;*/
    padding-left: 15px;
}
/*我的帖子*/
#my .menuFour ul .my-post a{
  background: url(/static/img/new-doc.png)no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*验房记录*/
#my .menuFour ul .home-inspection-application a{
  background: url(/static/img/home-inspection-application.png)no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*验房记录*/
#my .menuFour ul .decorate-to-apply-for a{
  background: url(/static/img/decorate-to-apply-for.png)no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*#my .menuFour ul li a {
	  background-position: 0px 35px;
    background-size: 20px 20px;
}*/
/*#my .menuFour ul .hisOrder a{
    background: url(/static/img/hisOrder.png)no-repeat;
    background-position: 0px 35px;
    background-size: 30px 30px;
}*/
#my .menuFour ul .address a{
    background: url(/static/img/address.png)no-repeat;
    background-position: 0px 35px;
    background-size: 30px 30px;
}
#my .menuFour input{
    width: 690px;
    height: 90px;
    font-size: 30px;
    color: #fff;
    border-radius: 45px;
    background-color: #d70b19;
    margin-top: 198px;
    margin-bottom: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/xinyuan/my.vue